import { render } from "./ReviewDetailModal.vue?vue&type=template&id=db8b1850&scoped=true"
import script from "./ReviewDetailModal.vue?vue&type=script&lang=js"
export * from "./ReviewDetailModal.vue?vue&type=script&lang=js"

import "./ReviewDetailModal.vue?vue&type=style&index=0&id=db8b1850&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-db8b1850"]])

export default __exports__